(function () {

    'use strict';

    if (typeof window === 'undefined') {

        utils(
            module.exports,
            require('../data/channels.js'),
            require('../../enums/metrics.js'),
            require('../../enums/timePeriod.js'),
            require('lodash')
        );

    } else {
        utils(
            RivalIQ.module('utils.metric'),
            RivalIQ.data.channels,
            RivalIQ.enums,
            RivalIQ.enums.timePeriod,
            window._
        );
    }

    const DAILY_VALUE_TO_TOTALS = {
        average_daily_page_views_total: 'page_views_total',
        average_daily_page_total_actions: 'page_total_actions',
        average_daily_page_engaged_users: 'page_engaged_users',
        average_daily_page_negative_feedback_unique: 'page_negative_feedback_unique',
        average_daily_page_posts_impressions_unique: 'page_posts_impressions_unique',
        average_daily_page_posts_impressions_paid_unique: 'page_posts_impressions_paid_unique',
        average_daily_page_posts_impressions_organic_unique: 'page_posts_impressions_organic_unique',
        average_daily_page_posts_impressions_viral_unique: 'page_posts_impressions_viral_unique',
        average_daily_page_posts_impressions_nonviral_unique: 'page_posts_impressions_nonviral_unique',
        average_daily_page_posts_impressions: 'page_posts_impressions',
        average_daily_page_posts_impressions_paid: 'page_posts_impressions_paid',
        average_daily_page_posts_impressions_organic: 'page_posts_impressions_organic',
        average_daily_page_posts_impressions_viral: 'page_posts_impressions_viral',
        average_daily_page_posts_impressions_nonviral: 'page_posts_impressions_nonviral',
        average_daily_page_impressions: 'page_impressions',
        page_video_views_organic_per_day: 'page_video_views_organic',
        page_video_views_paid_per_day: 'page_video_views_paid'

    };

    function utils(exports, channels, metricEnums, timePeriodEnums, _) {

        const applauseMapping = {
            twitter: 'favorites',
            facebook: 'posts_reactions',
            youtube: 'posts_likes',
            instagram: 'posts_likes',
            linkedin: 'update_likes',
            tiktok: 'posts_diggs'
        };

        const conversationMapping = {
            twitter: 'replies',
            facebook: 'posts_comments',
            youtube: 'posts_comments',
            instagram: 'posts_comments',
            linkedin: 'update_comments',
            tiktok: 'posts_comments'
        };

        const amplificationMapping = {
            twitter: 'retweets',
            facebook: 'posts_shares',
            linkedin: 'update_shares',
            tiktok: 'posts_shares'
        };

        const actionMapping = {
            linkedin: 'update_clicks'
        };

        const mappingsByEngagementType = {
            applause: applauseMapping,
            conversation: conversationMapping,
            amplification: amplificationMapping,
            action: actionMapping
        };

        const skipDailyPrefix = {
            linkedin: true
        };

        const pageConversationMapping = {
            youtube: 'comments'
        };

        const pageApplauseMapping = {
        };

        const genderMapping = {
            male: 'M',
            female: 'F',
            unspecified: 'U'
        };

        function postName(channel) {
            if (channel === 'twitter') {
                return 'tweet';
            }

            return 'post';
        }

        const propertyMap = {
            likely_promoted: function (channel, daily) {
                return (daily ? 'daily_likely_promoted_posts' : 'likely_promoted_posts');
            },
            estimated_impressions: function (channel, daily) {
                return (daily ? 'daily_estimated_impressions' : 'estimated_impressions');
            },
            engagement_rate_by_estimated_impression: function (channel, daily) {
                return (daily ? 'daily_engagement_rate_by_estimated_impression' : 'engagement_rate_by_estimated_impression');
            },
            presence_handle: function (channel) {
                if (['instagram', 'twitter'].indexOf(channel) >= 0) {
                    return 'handle';
                }

                return 'presence_handle';
            },
            presence_reach: function (channel, daily, mapping) {
                if (!channel) {
                    return 'total_reach';
                }

                if (channel === 'linkedin') {
                    if (mapping.impression_type) {
                        return `${mapping.impression_type}_followers`;
                    }
                    if (mapping.job_function) {
                        const job = (mapping.job_function === '' ? 'none' : mapping.job_function);
                        return `followers_by_job_function_${job}`;
                    }

                    return 'followers';
                }

                return 'audience';
            },
            backfilled_presence_reach: function (channel) {
                if (!channel) {
                    return 'total_reach';
                }
                return 'presence_reach';
            },
            total_post_reach: function (channel, daily) {
                if (!channel) {
                    return 'total_post_reach';
                }
                // NOTE intentional, this field does not seem to use post names
                return (daily ? 'daily_total_post_reach' : 'total_post_reach');
            },
            presence_reach_adds: function (channel, daily, mapping) {
                if (mapping.impression_type) {
                    return `${mapping.impression_type}_follower_adds`;
                }

                return 'follower_adds';
            },
            applause: function (channel) {
                return pageApplauseMapping[channel];
            },
            conversation: function (channel) {
                return pageConversationMapping[channel];
            },
            engagement_total: function (channel, daily, mapping) {
                let base;
                const name = postName(channel);

                if (!channel) {
                    return `total_${mapping.engagement_type || 'engagement'}`;
                }

                if (channel === 'linkedin') {
                    const propertyName = _.get(mappingsByEngagementType, [mapping.engagement_type, channel]) || 'engagement_total';
                    return propertyName;
                }

                if (!mapping.engagement_type) {
                    if (channel === 'linkedin') {
                        return 'engagement';
                    }

                    base = `${name}s_engagement_total`;
                    return (daily ? `daily_${base}` : base);
                }

                if (mapping.engagement_type === 'applause') {
                    if (!channel) {
                        return 'total_applause';
                    }

                    if (mapping.reaction_type) {
                        return (daily ? `daily_posts_${mapping.reaction_type}` : `posts_${mapping.reaction_type}`);
                    }

                    base = applauseMapping[channel];
                    if (skipDailyPrefix[channel]) {
                        return base;
                    }
                    return (daily ? `daily_${base}` : base);
                }

                if (mapping.engagement_type === 'conversation') {
                    if (!channel) {
                        return 'total_conversation';
                    }

                    base = conversationMapping[channel];
                    if (skipDailyPrefix[channel]) {
                        return base;
                    }
                    return (daily ? `daily_${base}` : base);
                }

                if (mapping.engagement_type === 'amplification') {
                    if (!channel) {
                        return 'total_amplification';
                    }

                    base = amplificationMapping[channel];
                    if (skipDailyPrefix[channel]) {
                        return base;
                    }
                    return (daily ? `daily_${base}` : base);
                }

                if (mapping.engagement_type === 'action') {
                    return actionMapping[channel];
                }
            },
            engagement_total_tweets_and_replies: function (channel, daily, mapping) {
                return (daily ? 'daily_engagement_total_tweets_and_replies' : 'engagement_total_tweets_and_replies');
            },
            page_engagement_total: function (channel, daily, mapping) {
                const propertyName = _.get(mappingsByEngagementType, [mapping.engagement_type, channel]) || 'engagement_total';
                return `page_${propertyName}`;
            },
            engagement_total_per_post: function (channel, daily, mapping) {
                if (!channel) {
                    return 'average_post_engagement_total';
                }

                if (channel === 'twitter' && mapping.engagement_type) {
                    const property = propertyMap.engagement_total(channel, true, mapping);
                    return (daily ? property : `average_${property}_engagement_total`);
                }

                if (channel === 'linkedin') {
                    const propertyName = _.get(mappingsByEngagementType, [mapping.engagement_type, channel]) || 'engagement_total';
                    return `${propertyName}_per_post`;
                }

                const name = postName(channel);
                return (daily ? `daily_average_${name}_engagement_total` : `average_${name}_engagement_total`);
            },
            engagement_total_per_view: function (channel, daily) {
                return (daily ? 'daily_engagement_total_per_view' : 'engagement_total_per_view');
            },
            avg_engagement_total_per_day: function (channel, daily, mapping) {
                const property = propertyMap.engagement_total(channel, true, mapping);
                return (daily ? property : `average_${property}`);
            },
            engagement_rate: function (channel, daily) {
                if (channel === 'linkedin') {
                    return 'engagement_rate';
                }

                const name = postName(channel);
                return (daily ? `daily_${name}s_engagement_rate` : `${name}s_engagement_rate`);
            },
            avg_engagement_rate_per_post: function (channel, daily) {
                if (!channel) {
                    return 'avg_engagement_rate_per_post';
                }

                const name = postName(channel);
                return (daily ? `daily_average_${name}_engagement_rate` : `average_${name}_engagement_rate`);
            },
            avg_engagement_rate_per_day: function (channel, daily) {
                const name = postName(channel);
                return (daily ? `daily_${name}s_engagement_rate` : `average_daily_${name}s_engagement_rate`);
            },
            lifetime_count: function (channel) {
                if (channel === 'twitter') {
                    return 'lifetime_tweets';
                }
                if (channel === 'instagram') {
                    return 'media';
                }

                return 'pins';
            },
            count: function (channel, daily, mapping) {
                if (!channel) {
                    return 'total_activity';
                }

                if (mapping.tweetType) {
                    return `${(daily ? 'daily_' : '') + mapping.tweetType}_tweets`;
                }

                if (channel === 'twitter') {
                    return (daily ? 'daily_normal_tweets' : 'normal_tweets');
                }

                if (channel === 'linkedin') {
                    return 'count';
                }

                const name = postName(channel);
                return (daily ? `daily_${name}s` : `${name}s`);
            },
            avg_count_per_day: function (channel, daily, mapping) {
                if (mapping.tweetType) {
                    return (daily ? `daily_${mapping.tweetType}_tweets` : `average_daily_${mapping.tweetType}_tweets`);
                }

                if (channel === 'twitter') {
                    return (daily ? 'daily_normal_tweets' : 'average_daily_normal_tweets');
                }

                const name = postName(channel);
                return (daily ? `daily_${name}s` : `average_daily_${name}s`);
            },
            avg_count_per_week: function (channel, daily, mapping) {
                if (mapping.tweetType) {
                    return `average_weekly_${mapping.tweetType}_tweets`;
                }

                if (channel === 'twitter') {
                    return 'average_weekly_normal_tweets';
                }

                const name = postName(channel);
                return `average_weekly_${name}s`;
            },
            post_impressions: function (channel) {
                if (channel === 'instagram') {
                    return 'post_impressions';
                }

                // Linkedin
                return 'page_update_impressions';
            },
            // NOTE These exist so that twitter can display a count w/
            // tweetType breakdown since `count` is remapped to just normal
            // tweets
            all_count: function (channel, daily, mapping) {
                if (channel === 'twitter') {
                    if (mapping.tweetType) {
                        return `${(daily ? 'daily_' : '') + mapping.tweetType}_tweets`;
                    }

                    return (daily ? 'daily_tweets' : 'tweets');
                }

                return propertyMap.count(channel, daily, mapping);
            },
            all_avg_count_per_day: function (channel, daily, mapping) {
                if (channel === 'twitter') {
                    if (mapping.tweetType) {
                        return (daily ? `daily_${mapping.tweetType}_tweets` : `average_daily_${mapping.tweetType}_tweets`);
                    }

                    return (daily ? 'daily_tweets' : 'average_daily_tweets');
                }

                return propertyMap.avg_count_per_day(channel, daily, mapping);
            },
            all_avg_count_per_week: function (channel, daily, mapping) {
                if (channel === 'twitter') {
                    if (mapping.tweetType) {
                        return `average_weekly_${mapping.tweetType}_tweets`;
                    }

                    return 'average_weekly_tweets';
                }

                return propertyMap.avg_count_per_week(channel, daily, mapping);
            },
            overview: function (channel) {
                if (channel === 'domain') {
                    return 'meta_description';
                }

                if (channel === 'tiktok') {
                    return 'signature';
                }

                return 'overview';
            },
            following: function (channel) {
                if (channel === 'twitter') {
                    return 'following';
                }

                return 'follows';
            },

            // FB Insights
            average_daily_page_total_actions: function (channel, daily) {
                if (daily) {
                    return 'page_total_actions';
                } else {
                    return 'average_daily_page_total_actions';
                }
            },
            average_daily_page_views_total: function (channel, daily) {
                if (daily) {
                    return 'page_views_total';
                } else {
                    return 'average_daily_page_views_total';
                }
            },
            impressions: function (channel, daily, mapping) {

                // INSTAGRAM_INSIGHTS
                if (channel === 'instagram') {
                    return 'impressions';
                }

                if (channel === 'linkedin') {
                    return 'impressions';
                }

                if (channel === 'twitter') {
                    return (daily ? 'daily_impressions' : 'impressions');
                }

                if (mapping.impression_type) {
                    return `page_impressions_${mapping.impression_type}`;
                }

                return 'page_impressions';
            },
            unique_impressions: function (channel, daily, mapping) {
                let suffix = 'unique';
                if (mapping.impression_type) {
                    suffix = `${mapping.impression_type}_unique`;
                }

                if (mapping.gender) {
                    if (mapping.age_range) {
                        if (daily) {
                            return [
                                'page_impressions_by_age_gender_unique.submetrics',
                                genderMapping[mapping.gender],
                                'submetrics',
                                mapping.age_range,
                                'value'
                            ].join('.');
                        }

                        return [
                            'average_daily_page_impressions_by_age_gender_unique.submetrics',
                            genderMapping[mapping.gender],
                            'submetrics',
                            mapping.age_range,
                            'value'
                        ].join('.');
                    }

                    if (daily) {
                        return [
                            'page_impressions_by_age_gender_unique.submetrics',
                            genderMapping[mapping.gender],
                            'value'
                        ].join('.');
                    }

                    return [
                        'average_daily_page_impressions_by_age_gender_unique.submetrics',
                        genderMapping[mapping.gender],
                        'value'
                    ].join('.');
                }

                return (daily ? 'page_impressions_' : 'average_daily_page_impressions_') + suffix;
            },
            impressions_per_day: function (channel, daily, mapping) {
                const prefix = (daily ? '' : 'average_daily_');
                const suffix = (mapping.impression_type ? `_${mapping.impression_type}` : '');

                return `${prefix}page_impressions${suffix}`;
            },
            consumptions: function (channel, daily, mapping) {
                if (mapping.consumption_type) {
                    return `page_consumptions_by_consumption_type.submetrics.${mapping.consumption_type.replace('_', ' ')}.value`;
                }

                return 'page_consumptions';
            },
            unique_consumptions: function (channel, daily, mapping) {
                if (mapping.consumption_type) {
                    const suffix = `${mapping.consumption_type.replace('_', ' ')}.value`;
                    return (daily ?
                        'page_consumptions_by_consumption_type_unique.submetrics.' :
                        'average_daily_page_consumptions_by_consumption_type_unique.submetrics.') +
                        suffix;
                }

                return (daily ? 'page_consumptions_unique' : 'average_daily_page_consumptions_unique');
            },
            all_presence_reach: 'fan_count',
            page_fans: function (channel, daily, mapping) {
                if (mapping.gender) {
                    if (mapping.age_range) {
                        return [
                            'page_fans_gender_age.submetrics.',
                            genderMapping[mapping.gender],
                            '.submetrics.',
                            mapping.age_range,
                            '.value'
                        ].join('');
                    }

                    return ['page_fans_gender_age.submetrics.',
                        genderMapping[mapping.gender],
                        '.value'].join('');
                }

                return 'page_fans';
            },
            unique_page_fan_adds: 'page_fan_adds_unique',
            page_fan_adds: function (channel, daily, mapping) {
                if (mapping.pay_type) {
                    return `page_fan_adds_by_paid_non_paid_unique.submetrics.${mapping.pay_type}.value`;
                }

                return 'page_fan_adds';
            },
            unique_page_fan_removes: 'page_fan_removes_unique',
            page_fan_removes: 'page_fan_removes',

            phone_call_clicks: function (channel) {
                return (channel === 'facebook' ? 'page_call_phone_clicks_logged_in_unique' : 'phone_call_clicks');
            },

            direction_clicks: function (channel) {
                return (channel === 'facebook' ? 'page_get_directions_clicks_logged_in_unique' : 'direction_clicks');
            },

            website_clicks: function (channel) {
                return (channel === 'facebook' ? 'page_website_clicks_logged_in_unique' : 'website_clicks');
            },

            cta_button_clicks: 'page_cta_clicks_logged_in_unique',

            page_video_views_per_day: function (channel, daily) {
                return (daily ? 'page_video_views' : 'page_video_views_per_day');
            },

            // Only used by YouTube
            page_views: 'views',
            post_views: function (channel, daily) {
                return (daily ? 'daily_post_views' : 'post_views');
            },
            views: function (channel, daily) {
                if (channel === 'facebook') {
                    return (daily ? 'daily_views' : 'views');
                }
                return (daily ? 'daily_posts_views' : 'posts_views');
            },
            video_views: function (channel, daily, mapping) {
                let summaryMetric;
                let dailyMetric = 'daily_posts_views';
                if (channel === 'twitter') {
                    return (daily ? 'daily_views' : 'video_views');
                } else if (channel === 'instagram') {
                    summaryMetric = 'video_views';

                    if (mapping.source === metricEnums.sources.INSTAGRAM_INSIGHTS) {
                        dailyMetric = 'video_views';
                    }
                } else if (channel === 'linkedin') {
                    return 'video_views';
                } else {
                    summaryMetric = 'posts_views';
                }

                return (daily ? dailyMetric : summaryMetric);
            },
            video_views_per_day: function (channel, daily) {
                if (channel === 'twitter') {
                    return (daily ? 'daily_views' : 'average_daily_video_views');
                }
                return 'video_views_per_day';
            },
            views_per_post: function (channel, daily) {
                return (daily ? 'daily_views_per_post' : 'views_per_post');
            },
            views_per_follower: function (channel, daily) {
                return (daily ? 'daily_views_per_follower' : 'views_per_follower');
            },
            avg_views_per_day: function (channel, daily) {
                return (daily ? 'daily_posts_views' : 'average_daily_posts_views');
            },
            keywords: function (channel) {
                if (channel === 'domain') {
                    return 'meta_keywords';
                }

                return 'keywords';
            },
            display_name: function (channel) {
                if (channel === 'instagram') {
                    return 'full_name';
                }
                return 'display_name';
            },
            // LINKEDIN
            unique_post_visitors: function (channel, daily) {
                return (daily ? 'unique_visitors' : 'average_unique_visitors');
            },
            overview_page_unique_views: function (channel, daily) {
                return (daily ? 'overview_page_unique_views' : 'average_overview_page_unique_views');
            },
            keywords_count: function (channel, daily, mapping) {
                if (mapping.impression_type === 'paid') {
                    return 'adwords_keywords';
                }
                return 'organic_keywords';
            },
            traffic: function (channel, daily, mapping) {
                if (mapping.impression_type === 'paid') {
                    return 'adwords_traffic';
                }
                return 'organic_traffic';
            },
            spend: function (channel, daily, mapping) {
                if (mapping.impression_type === 'paid') {
                    return 'adwords_cost';
                }
                return 'organic_cost';
            },

            // INSTAGRAM_INSIGHTS
            post_impressions_per_day: function (channel, daily) {
                if (channel === 'linkedin') {
                    return (daily ? 'page_update_impressions' : 'page_update_impressions_per_day');
                }
                return (daily ? 'post_impressions' : 'post_impressions_per_day');
            },
            total_num_stories: 'num_stories',
            audience_gender_age: generateInstagramAgeGenderMapping('audience_gender_age'),
            page_impressions_per_day: function (channel, daily) {
                return (daily ? 'page_impressions' : 'page_impressions_per_day');
            },
            page_reach_per_day: function (channel, daily) {
                return (daily ? 'page_reach' : 'page_reach_per_day');
            }
        };

        function generateInstagramAgeGenderMapping(propertyName) {
            return function (channel, daily, mapping) {
                if (mapping.gender) {
                    if (mapping.age_range) {
                        return [
                            propertyName,
                            '.submetrics.',
                            genderMapping[mapping.gender],
                            '.submetrics.',
                            mapping.age_range,
                            '.value'
                        ].join('');
                    }

                    return [propertyName,
                        '.submetrics.',
                        genderMapping[mapping.gender],
                        '.value'].join('');
                }

                return [propertyName, 'value'].join('.');
            };
        }

        function makeCompanyDataKeyForAggregate(aggregate, property, mapping) {
            const timeAnalysisMode = mapping.timeAnalysisMode;

            let tamPrefix = '';
            if (_.includes([metricEnums.timeAnalysisMode.DELTA_ABSOLUTE, metricEnums.timeAnalysisMode.DELTA_RELATIVE], timeAnalysisMode)) {
                tamPrefix = `${exports.timeAnalysisModeToCompanyDataKey(timeAnalysisMode)}_`;
            }

            return `${tamPrefix}${aggregate}_${property}`;
        }

        exports.metricToCompanyDataKey = function (property, mapping, daily, aggregate) {

            // Twitter insights is new and doesn't play this game.
            if (mapping.source === metricEnums.sources.TWITTER_INSIGHTS) {
                if (aggregate) {
                    return makeCompanyDataKeyForAggregate(aggregate, property, mapping);
                } else {
                    return property;
                }
            }

            if (mapping.source === metricEnums.sources.FACEBOOK_INSIGHTS && DAILY_VALUE_TO_TOTALS[property] && daily) {
                return DAILY_VALUE_TO_TOTALS[property];
            }

            let res = propertyMap[property];
            if (_.isFunction(res)) {
                res = res(mapping.channel, daily, mapping);
            } else {
                res = (_.isUndefined(res) ? property : res);
            }

            if (aggregate) {
                res = makeCompanyDataKeyForAggregate(aggregate, res, mapping);
            }

            return res;
        };

        const types = {};
        types[metricEnums.timeAnalysisMode.MAIN_PERIOD] = 'period2';
        types[metricEnums.timeAnalysisMode.COMPARE_PERIOD] = 'period1';
        types[metricEnums.timeAnalysisMode.DELTA_ABSOLUTE] = 'deltaAbsolute';
        types[metricEnums.timeAnalysisMode.DELTA_RELATIVE] = 'deltaRelative';
        types[metricEnums.timeAnalysisMode.DAILY_VALUES] = 'dailyValues';

        const dailyTypes = {};
        dailyTypes[metricEnums.timeAnalysisMode.MAIN_PERIOD] = 'dailyValues';
        dailyTypes[metricEnums.timeAnalysisMode.COMPARE_PERIOD] = 'dailyValuesPeriod1';

        const durationTypes = {};
        durationTypes[metricEnums.timeAnalysisMode.MAIN_PERIOD] = 'mainPeriodDuration';
        durationTypes[metricEnums.timeAnalysisMode.COMPARE_PERIOD] = 'comparePeriodDuration';
        durationTypes[metricEnums.timeAnalysisMode.DELTA_ABSOLUTE] = 'mainPeriodDuration';
        durationTypes[metricEnums.timeAnalysisMode.DELTA_RELATIVE] = 'mainPeriodDuration';

        exports.timeAnalysisModeToCompanyDataKey = function (mode, day, property) {
            if (!_.isUndefined(day)) {
                return dailyTypes[mode];
            }

            // TODO make less of a hack
            if (_.includes([
                'overview',
                'title',
                'keywords',
                'verified',
                'about',
                'display_name',
                'icon_url',
                'presence_handle',
                'location',
                'url',
                'joined_at'
            ], property)) {
                if (mode === metricEnums.timeAnalysisMode.MAIN_PERIOD) {
                    return 'presence';
                }
                // NOTE no non-main period values for text metrics
                return;
            }

            return types[mode];
        };

        exports.channelToCompanyDataKey = function (channel, source) {
            if (_.isUndefined(source)) {
                return channels.get(channel).get('trendKey');
            }

            return channels.get(source).get('trendKey');
        };

        exports.companyDataStartDateKey = function (timeAnalysisMode) {
            if (timeAnalysisMode === metricEnums.timeAnalysisMode.COMPARE_PERIOD) {
                return 'comparePeriodStart';
            }

            return 'mainPeriodStart';
        };

        exports.companyDataDurationKey = function (timeAnalysisMode) {
            if (timeAnalysisMode === metricEnums.timeAnalysisMode.COMPARE_PERIOD) {
                return 'comparePeriodDuration';
            }

            return 'mainPeriodDuration';
        };

        exports.companyDataEndDateKey = function (timeAnalysisMode) {
            if (timeAnalysisMode === metricEnums.timeAnalysisMode.COMPARE_PERIOD) {
                return 'comparePeriodEnd';
            }

            return 'mainPeriodEnd';
        };

        exports.dimensionValuesFromCompanyData = function (company, dimension, type, channel, metric) {
            // NOTE on the server the company is not a model
            const summary = (company.get ? company.get('periodSummary') : company.periodSummary);

            if (dimension === 'channel') {
                return channels.inCrossChannel().reduce(function (memo, c) {
                    const hasTrends = (_.size(summary[c.get('trendKey')]) > 0);
                    return (hasTrends ? memo.concat(c.get('channel')) : memo);
                }, []);
            }

            if (dimension === timePeriodEnums.interval.daily) {
                return _.range(0, summary.dates[durationTypes[type]]);
            }

            if (dimension === 'engagement_type') {
                if (channel) {
                    return channels.get(channel).get('engagementTypes');
                }
                return ['applause', 'amplification', 'conversation'];
            }

            if (dimension === 'tweetType') {
                return ['normal', 'retweet', 'reply'];
            }

            if (dimension === 'reaction_type') {
                return [
                    'likes',
                    'loves',
                    'hahas',
                    'wows',
                    'sads',
                    'angrys'
                ];
            }

            if (dimension === 'timeAnalysisMode') {
                return _.filter([
                    metricEnums.timeAnalysisMode.MAIN_PERIOD,
                    metricEnums.timeAnalysisMode.DELTA_RELATIVE,
                    metricEnums.timeAnalysisMode.COMPARE_PERIOD,
                    metricEnums.timeAnalysisMode.DELTA_ABSOLUTE,
                    (metric.get('useUniversalMetricsApi') ? metricEnums.timeAnalysisMode.DAILY_VALUES : null)
                ], _.isNumber);
            }
        };

        exports.filterFreeDimensions = function (def) {
            const dimensions = _.get(def, 'dimensions', []);
            return _.reduce(dimensions, function (memo, dimension) {
                return (_.isUndefined(def[dimension]) ? memo : memo.concat(dimension));
            }, []);
        };

        exports.formatDimensionFn = function (name) {
            return function (value, metric, options, dimension) {
                // If we are fetching a formatted value cross channel, add the
                // channel name
                if (dimension === 'channel' && !metric[dimension]) {
                    const dimensionFormat = channels.get(value).get('name');
                    return `${dimensionFormat} ${name}`;
                }

                return name;
            };
        };

        // subtly change some descriptions depending on context
        exports.useDetailsDescription = function (metric) {
            return _.some(metric.dimensions, function (dimension) { return _.includes(dimension, 'post'); });
        };

        exports.useCustomDashboardDescription = function (metric) {
            return (_.isUndefined(metric.id) || metric.useUniversalMetricsApi);
        };

        /**
         * snakeCase/camelCase with special exceptions for special metrics.
         */
        exports.snakeCaseMetricName = function (name) {
            // Ensure "youTube Foo" gets snake-cased as "youtube_foo".
            name = name.replace(/youtube/i, 'youtube');
            name = name.replace(/tiktok/i, 'tiktok');

            return _.snakeCase(name);
        };

        /**
         * snakeCase/camelCase with special exceptions for special metrics.
         */
        exports.camelCaseMetricName = function (name) {

            // make sure all words are capitalized so camel case will work correctly
            name = _.map(_.words(name), function (word) {
                return _.upperFirst(word);
            }).join(' ');

            name = _.camelCase(name);

            // Ensure "youtube foo" gets camel-cased as "youTubeFoo".
            name = name.replace(/youtube/i, 'youTube');
            name = name.replace(/tiktok/i, 'tikTok');

            return name;
        };

        exports.genderAgeNames = function (gender, age) {
            return {
                gender: gender[0].toUpperCase() + gender.substring(1),
                title: (gender === 'female' ? 'women' : (gender === 'male' ? 'men' : 'gender-unspecified persons')),
                age: age
            };
        };

        exports.mappingsByEngagementType = mappingsByEngagementType;
    }
})();
